import React from 'react';
import { cn } from '@/lib/cn';

export interface BuildingMetricProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string;
  unit?: string;
}

/**
 * BuildingMetric
 * Small metric block for violations per unit (owner/NYC).
 */
export function BuildingMetric({
  label,
  value,
  unit = 'Violations per unit',
  className,
  ...props
}: BuildingMetricProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)} {...props}>
      <span className="text-body-2 text-secondary">{label}</span>
      <span className="text-heading-5 text-primary">{value}</span>
      {unit ? <span className="text-body-2 text-secondary">{unit}</span> : null}
    </div>
  );
}

export default BuildingMetric;
